import styled from "@emotion/styled";
import { margin as polishedMargin } from "polished";

import {
  desktop,
  tablet,
  mobile,
  type SpacingValues,
} from "@brexhq/shared/types/SpacingScale";

export const StyledTopSpacing = styled.div<{
  margin: SpacingValues;
}>(({ theme, margin }) => {
  const {
    breakpoints: { MED, SML },
  } = theme;

  return {
    ...polishedMargin(desktop[margin], 0, 0, 0),
    [MED]: { ...polishedMargin(tablet[margin], 0, 0, 0) },
    [SML]: {
      ...polishedMargin(mobile[margin], 0, 0, 0),
    },
  };
});
